import { useMutation } from '@tanstack/react-query';
import {
  type ClientMonitoringEventDto,
  useApi,
} from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type UseSendErrorMonitoringEvent = Omit<
  ClientMonitoringEventDto,
  'type' | 'responseTime'
>;
export function useSendErrorMonitoringEvent() {
  const api = useApi();

  return useMutation<void, ExtendedAxiosError, UseSendErrorMonitoringEvent>({
    mutationKey: ['monitoring'],
    mutationFn: (r) =>
      api.monitoringApi.sendEvent({ ...r, type: 'error' }).then((r) => r.data),
  });
}
